import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Validation } from '../../helper';
import { UserActions } from '../../actions';
import { Submit, Input } from '../Form';

class RegisterForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: "",
            email: "",
            password: "",
            error: {
                name: false,
                email: false,
                password: false
            }
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    validation() {
        var err = {
            name: false,
            email: false,
            password: false
        
        }
        if(!Validation.fullName(this.state.name)) err.name = true;
        if(!Validation.password(this.state.password)) err.password = true;
        if(!Validation.email(this.state.email)) err.email = true;        

        this.setState({error: err});
        
        return !err.name && !err.email && !err.password;
    }

    handleSubmit (event) {
        event.preventDefault();

        // if reuest in process
        if(this.props.register.process === true) return;

        const errorEmail = this.props.register.errorEmail;
        const propsRegisterData = this.props.register.data;
        const propsEmail = propsRegisterData ? propsRegisterData.email : null;
        
        // if has email error (duplicate) & user not change it -> dont send request
        if(errorEmail === true && propsEmail === this.state.email) return;

        // validation ok 
        if(this.validation()) {
            const {dispatch} = this.props;

            dispatch(UserActions.register({
                email: this.state.email,
                password: this.state.password,
                name: this.state.name
            }));
        }
    }

    render() {
        const emailAlreadyExists = this.props.register.errorEmail === true;
        const requestInProcess = this.props.register.process === true;

        return (
            <div id="registerForm" className='register-form-template'>
                <div className="form-title">
                    הרשמה
                </div>
                <form onSubmit={this.handleSubmit} noValidate>
                    <Input
                        name="name"
                        value={this.state.name}
                        placeholder="שם מלא"
                        error={this.state.error.name}
                        errorText="שם מלא לא תקין"
                        onChange={this.handleChange}
                    />
                    <Input
                        name="email"
                        value={this.state.email}
                        placeholder="אימייל"
                        error={this.state.error.email || emailAlreadyExists}
                        errorText={emailAlreadyExists ? 'אימייל זה שייך למשתמש אחר' : 'אימייל לא תקין'}
                        onChange={this.handleChange}
                        type="email"
                    />
                    <Input
                        name="password"
                        value={this.state.password}
                        placeholder='סיסמא (לפחות 8 תווים)'
                        error={this.state.error.password}
                        errorText='סיסמא לא תקינה'
                        onChange={this.handleChange}
                        type="password"
                    />
                    <Submit process={requestInProcess} icon="faUserPlus" text="הרשמה"/>
                </form>
                <Link to="/login"><small>יש לי כבר חשבון</small></Link>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        register: state.registerReducer
    }
}

const RegisterFormWithRedux = connect(mapStateToProps)(RegisterForm);

export {RegisterFormWithRedux as RegisterForm};


// WEBPACK FOOTER //
// ./src/components/RegisterPage/RegisterForm.jsx